module.exports = __webpack_public_path__ + "static/img/zeta_template_01.d4ede05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeta_template_01.png
// module id = wLxC
// module chunks = 1